export default function CategoryTree(props) {
    const { category, children, render, search } = props;

    return (
        <>
            {
                category && render(category)
            }
            <ul>
                {
                    children.map(
                        (c) => (
                            <li key={ c.category.id }>
                                <CategoryTree
                                    render={ render }
                                    search={ search }
                                    { ...c }
                                />
                            </li>
                        )
                    )
                }
            </ul>
        </>
    );
}
